export default {
  zh: {
    // 首屏内容
    hero: {
      title: "破解<br />多云选择与成本复杂性",
      titleHighlight: "释放云基础设施的长期价值",
      description:
        "通过统一的云资源管理与优化能力，帮助企业提升可视性与可控性，让云真正服务于业务增长。",
      descriptionMobile:
        "通过统一的云资源管理与优化能力，<br />帮助企业提升可视性与可控性，<br />让云真正服务于业务增长。",
      ctaButton: "立即咨询",
    },
    // 解决方案双引擎
    solutionsSection: {
      title: 'Nexcor双引擎方案：从"选好云"到"用好云"',
      cloudPurchasing: {
        title: "一站式云采购解决方案",
        subtitle: '助力企业"选好云"',
        description:
          "汇聚主流云厂商资源，直采更优惠；合同灵活、技术专业、支持 7×24 服务，并提供降本增效方案，让企业采购云更省心、更高效。",
        features: {
          vendors: {
            title: "覆盖主流厂商",
            subtitle: "选择更自由",
            description:
              "全面代理AWS、阿里云、GCP、腾讯云、华为云、Azure、Linode 等国内外所有主流云厂商。",
          },
          pricing: {
            title: "尊享更优价格",
            subtitle: "成本更可控",
            description:
              "我们与国内外主流云厂商保持长期深度合作，并获得其强有力的优惠政策支持。",
          },
          service: {
            title: "获得专业服务",
            subtitle: "过程更安心",
            description:
              "团队长期深耕云计算领域，在大数据及架构优化方面经验丰富，提供7*24小时专业技术支持服务。",
          },
        },
      },
      devfinops: {
        title: "DevFinOps多云降本解决方案",
        subtitle: '助力企业"用好云"',
        description:
          "基于FinOps创新的成本管理理念与过往大量的多云应用实践沉淀而来，以一站式云成本数据分析功能为依托，可为企业提供从0到1的陪跑式云成本优化服务，助力企业在用云全生命周期中，高效优化云资源成本，实现财务透明化和效益最大化。",
        stats: {
          amount: {
            data: "11",
            unit: "亿",
            description: "累计云上管理金额",
          },
          optimization: {
            data: "31.5",
            unit: "%",
            description: "平均云成本优化率",
          },
        },
      },
    },
    // 数据分析功能
    analyticsSection: {
      title: '一站式云成本数据分析：从"成本可视"到"智能优化"',
      dataCollection: {
        title: "自动化数据采集",
        subtitle: "多云账单可视化分析",
        description:
          "以自研云成本数据分析工具为依托，不仅可以自动收集企业在全球各大云平台上的资源消耗情况，包括但不限于利用率、使用量等多维度数据指标；同时，还可以通过可视化的图表与定制化的报告，帮助企业一目了然地洞察成本波动，为企业最大限度优化资源配置，提供数据决策路径。",
        features: {
          unified: {
            title: "统一视图 跨云管理",
            description:
              "支持AWS、阿里云、GCP、腾讯云、OCI、Azure 等全球主流云厂商。",
          },
          customizable: {
            title: "自由定制 深度洞察",
            description:
              "可以根据自身的业务需求，自定义分析维度和图表样式，满足多元数据分析与决策需求。",
          },
          drilldown: {
            title: "层层下钻 杜绝浪费",
            description:
              "支持多达四层的账单下钻分析，帮助您追踪每一项费用的根源，深入洞察成本浪费。",
          },
        },
      },
      systemManagement: {
        title: "智能化系统管理",
        subtitle: "精准识别可优化资源",
        description:
          "在智能算法的加持下，可实时追踪企业在全球各地的云资源使用情况，把原本割裂的成本、使用量、利用率联系在一起，帮助企业快速识别成本异常与浪费点，如：未充分利用的资源、高峰时段的额外成本等；同时，还可以根据企业实际业务需求进行云资源的成本预测和预算设定，避免不必要的资金支出与资源浪费。",
        features: {
          identification: {
            title: "一键识别资源浪费",
            description:
              "自动识别闲置资源、未被充分利用的资源，以及付费方式不合理的资源。",
          },
          optimization: {
            title: "一键生成优化建议",
            description:
              "生成个性化优化建议，帮助用户调整资源配置，提高服务装箱率，降低云IT成本支出。",
          },
        },
      },
    },
  },
  en: {
    // Hero section
    hero: {
      title: "Breaking Multi-Cloud Selection<br />and Cost Complexity",
      titleHighlight: "Unlocking Long-Term Value of Cloud Infrastructure",
      description:
        "Through unified cloud resource management and optimization capabilities, helping enterprises improve visibility and controllability,<br />making cloud truly serve business growth.",
      descriptionMobile:
        "Through unified cloud resource management and optimization capabilities, helping enterprises improve visibility and controllability, making cloud truly serve business growth.",
      ctaButton: "Contact Now",
    },
    // Solutions section
    solutionsSection: {
      title:
        'Nexcor Dual-Engine Solutions: <br />From "Choosing the Right Cloud" to "Using Cloud Well"',
      cloudPurchasing: {
        title: "One-Stop Cloud Procurement Solution",
        subtitle: 'Helping Enterprises "Choose the Right Cloud"',
        description:
          "Direct access to top cloud vendors with flexible contracts, expert 24/7 support, and cost-saving solutions for easier procurement.",
        features: {
          vendors: {
            title: "Covering Mainstream Vendors",
            subtitle: "More Freedom of Choice",
            description:
              "Comprehensive agency for AWS, Alibaba Cloud, GCP, Tencent Cloud, Huawei Cloud, Azure, Linode and all other mainstream cloud vendors worldwide.",
          },
          pricing: {
            title: "Exclusive Better Pricing",
            subtitle: "More Controllable Costs",
            description:
              "We maintain long-term deep cooperation with mainstream cloud vendors worldwide and receive strong preferential policy support.",
          },
          service: {
            title: "Professional Service",
            subtitle: "More Peace of Mind",
            description:
              "Experienced in cloud computing and architecture optimization, providing 24/7 professional support.",
          },
        },
      },
      devfinops: {
        title: "DevFinOps Multi-Cloud Cost Reduction Solution",
        subtitle: 'Helping Enterprises "Use Cloud Well"',
        description:
          "Leveraging FinOps and multi-cloud experience, it offers end-to-end cloud cost optimization, maximizing transparency and resource efficiency.",
        stats: {
          amount: {
            data: "1.1",
            unit: "Billion",
            description: "Cumulative Cloud Management Amount",
          },
          optimization: {
            data: "31.5",
            unit: "%",
            description: "Average Cloud Cost Optimization Rate",
          },
        },
      },
    },
    // Analytics section
    analyticsSection: {
      title: `One-Stop Cloud Cost Data Analysis:<br /> From "Cost Visibility" to "Intelligent Optimization"`,
      dataCollection: {
        title: "Automated Data Collection",
        subtitle: "Multi-Cloud Bill Visualization Analysis",
        description:
          "Using proprietary cloud cost tools, it collects multi-dimensional resource data and visualizes cost trends, helping enterprises optimize resource allocation efficiently.",
        features: {
          unified: {
            title: "Unified View Cross-Cloud Management",
            description:
              "Supports AWS, Alibaba Cloud, GCP, Tencent Cloud, OCI, Azure and other global mainstream cloud vendors.",
          },
          customizable: {
            title: "Customizable Deep Insights",
            description:
              "Customizable charts and analysis to meet diverse business and decision-making needs.",
          },
          drilldown: {
            title: "Layer-by-Layer Drill-Down to Eliminate Waste",
            description:
              "Supports four-layer bill drill-down to track expenses and uncover cost waste",
          },
        },
      },

      systemManagement: {
        title: "Intelligent System Management",
        subtitle: "Precisely Identify Optimizable Resources",
        description:
          "Uses intelligent algorithms to track global cloud usage in real time, linking costs, usage, and utilization to spot anomalies and waste, and enabling cost forecasting and budget planning.",
        features: {
          identification: {
            title: "One-Click Resource Waste Identification",
            description:
              "Automatically identify idle resources, underutilized resources, and resources with unreasonable payment methods.",
          },
          optimization: {
            title: "One-Click Optimization Recommendation Generation",
            description:
              "Provides personalized optimization suggestions to adjust resources, improve utilization, and cut cloud IT costs.",
          },
        },
      },
    },
  },
};
